import { Company, Check } from 'src/types/data';

export function addCheckToCarnet(
  companies: Company[],
  companyId: number,
  ribId: number,
  carnetId: number,
  check: Check
): Company[] {
  return companies.map((company) => {
    if (company.id !== companyId) return company;

    return {
      ...company,
      ribs: company.ribs.map((rib) => {
        if (rib.id !== ribId) return rib;

        return {
          ...rib,
          carnets: rib.carnets.map((carnet) => {
            if (carnet.id !== carnetId) return carnet;

            return {
              ...carnet,
              checks: [...carnet.checks, check],
            };
          }),
        };
      }),
    };
  });
}

export function updateCheckInCarnet(
  companies: Company[],
  companyId: number,
  ribId: number,
  carnetId: number,
  updatedCheck: Partial<Check>
): Company[] {
  return companies.map((company) => {
    if (company.id !== companyId) return company;

    return {
      ...company,
      ribs: company.ribs.map((rib) => {
        if (rib.id !== ribId) return rib;

        return {
          ...rib,
          carnets: rib.carnets.map((carnet) => {
            if (carnet.id !== carnetId) return carnet;

            return {
              ...carnet,
              checks: carnet.checks.map((check) =>
                check.id === updatedCheck.id ? { ...check, ...updatedCheck } : check
              ),
            };
          }),
        };
      }),
    };
  });
}

export function removeCheckFromCarnet(
  companies: Company[],
  companyId: number,
  ribId: number,
  carnetId: number,
  checkId: number
): Company[] {
  return companies.map((company) => {
    if (company.id !== companyId) return company;

    return {
      ...company,
      ribs: company.ribs.map((rib) => {
        if (rib.id !== ribId) return rib;

        return {
          ...rib,
          carnets: rib.carnets.map((carnet) => {
            if (carnet.id !== carnetId) return carnet;

            return {
              ...carnet,
              checks: carnet.checks.filter((check) => check.id !== checkId),
            };
          }),
        };
      }),
    };
  });
}
